import { graphql } from "babel-plugin-relay/macro";

export const resetCardQL = graphql`
  mutation resetCardMutation($id: ID!, $loopFilter: LoopFilter) {
    resetCard(id: $id) {
      ...loopQuery_loop @arguments(loopFilter: $loopFilter)
    }
  }
`;
